// tabs/ThinkyBaaSOverview.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer, faUniversity, faHeartbeat, faSeedling } from "@fortawesome/free-solid-svg-icons";

const platformsData = [
  {
    title: "IBM Blockchain",
    description: "Enterprise BaaS for supply chain, finance, and healthcare. Hyperledger Fabric-based.",
    sectors: ["MSME", "Healthcare", "Agri"],
    icon: faServer,
  },
  {
    title: "AWS Managed Blockchain",
    description: "Cloud-managed blockchain supporting Hyperledger Fabric & Ethereum. Scalable enterprise applications.",
    sectors: ["MSME", "Agri", "Healthcare"],
    icon: faServer,
  },
  {
    title: "Blockcerts",
    description: "Open standard to issue and verify tamper-proof educational and professional credentials.",
    sectors: ["Education"],
    icon: faUniversity,
  },
  {
    title: "TransCrypts",
    description: "Blockchain-based identity and credential verification for education, healthcare, and HR.",
    sectors: ["Education", "Healthcare"],
    icon: faHeartbeat,
  },
  {
    title: "IBM Food Trust",
    description: "Blockchain network for end-to-end food and agriculture supply chain traceability.",
    sectors: ["Agri"],
    icon: faSeedling,
  },
];

const ThinkyBaaSOverview = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 place-items-center">
      {platformsData.map((platform, idx) => (
        <div
          key={idx}
          className="bg-gray-900 p-2 rounded-xl border border-gray-700 shadow-lg flex flex-col justify-start"
        >
          <FontAwesomeIcon icon={platform.icon} className="mb-2 text-xl lg:text-2xl text-blue-400 text-left justify-start items-center" />
          <h2 className="text-sm lg:text-lg font-semibold mb-2">{platform.title}</h2>
          <p className="text-gray-300 text-sm lg:text-lg mb-2">{platform.description}</p>
          <p className="text-sm text-gray-400">
            Sectors: {platform.sectors.join(", ")}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ThinkyBaaSOverview;
